"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconLife = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Life" }, props),
        react_1.default.createElement("title", null, "Life"),
        react_1.default.createElement("path", { d: "M60.364 37.136c7.888 0 14.282-6.395 14.282-14.282 0-7.888-6.394-14.283-14.282-14.283-7.887 0-14.282 6.395-14.282 14.283 0 7.887 6.395 14.282 14.282 14.282z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M100.371 71.421V31.425c-22.093 0-40.007 17.914-40.007 39.996h40.007z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M60.364 71.432v39.997c22.093 0 40.007-17.915 40.007-40.008l-40.007.011z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M60.364 71.421c0-22.092-17.914-40.007-40.007-40.007v39.997c0 22.103 17.914 40.018 40.007 40.018V71.421z", fill: "#D44513" })));
};
exports.default = BrandIconLife;
